import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import i18n from './i18n';
import Omnica from '@/plugins/omnica';
import { Captcha, CaptchaProvider } from '@/plugins/captcha';
import { Analytics } from '@/plugins/analytics';
import { Sentry } from '@/plugins/sentry';

import './assets/styles/main.less';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(Omnica);
app.use(Captcha, {
    siteKey: import.meta.env.VITE_CAPTCHA_SITE_KEY,
    provider: import.meta.env.VITE_CAPTCHA_PROVIDER as CaptchaProvider,
});
app.use(Analytics, {
    gtmId: import.meta.env.VITE_GTM_ID,
    metrikaId: import.meta.env.VITE_METRIKA_ID,
    vueRouter: router,
})
app.use(Sentry, {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    vueRouter: router,
})

app.mount('#app');
